import { createSlice } from "@reduxjs/toolkit";
import { getInsuredServiceAsync } from "./Actions";

export interface InsuredValues {
  value: string;
  label: string;
}

export interface InsuredState {
  status: "idle" | "loading" | "failed";
  insuredOptions: Array<InsuredValues>;
  errorMessage: string | undefined;
}

const initialState: InsuredState = {
  status: "idle",
  insuredOptions: [],
  errorMessage: "",
};

export const insuredSlice = createSlice({
  name: "Insured",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInsuredServiceAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getInsuredServiceAsync.rejected, (state, action: any) => {
        state.status = "failed";
        state.insuredOptions = [];
        state.errorMessage = action.payload && action.payload.errorMessage;
      })
      .addCase(getInsuredServiceAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.insuredOptions = action.payload;
        state.errorMessage = "";
      });
  },
});

export default insuredSlice.reducer;
